import React from 'react'
import { useQuery } from '@apollo/client'
import { useUserContext } from '../../context/UserContext'
import { GET_MANUFACTURE } from '../../apollo/queries/getManufacture'
import MainLayout from '../../components/Layout'
import ManufacturerUsers from './ManufacturerUsers'
import { BeatLoader } from 'react-spinners'

function Teams() {
    const { userData } = useUserContext()
    const { data, loading, error } = useQuery(GET_MANUFACTURE, {
        variables: { email: userData?.email },
        skip: !userData?.email,
    })

    const manufacturer = data?.getManufacturer?.[0]

    if (loading) {
        return (
            <MainLayout>
                <div className="flex items-center justify-center min-h-[400px]">
                    <BeatLoader color={'#2b364b'} />
                </div>
            </MainLayout>
        )
    }

    if (error || !manufacturer) {
        return (
            <MainLayout>
                <div className="flex flex-col items-center justify-center min-h-[400px]">
                    <h2 className="text-xl font-semibold text-red-600 mb-4 font-montserrat">
                        {error ? 'Error loading team members' : 'Manufacturer not found'}
                    </h2>
                    {error && <p className="text-gray-500 font-montserrat">{error.message}</p>}
                </div>
            </MainLayout>
        )
    }

    return (
        <MainLayout>
            <div className="mb-8 border-b border-gray-100 pb-4">
                <h1 className="admin-dashboard !leading-tight mb-2">Team Members</h1>
                <p className="text-gray-500 font-montserrat text-sm">Manage your team members and their access levels.</p>
            </div>
            <ManufacturerUsers manufacturer={manufacturer} />
        </MainLayout>
    )
}

export default Teams
